var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.type == 'Soteria.Models.StatisticVerticalBarChartDetails, Soteria.Models')?_c('vertical-bar-chart',{attrs:{"details":_vm.details}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }